import React, { Component } from "react";
import { FullPage } from "../components/general/fullPage/fullPage";

class Projects extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <FullPage />
      </React.Fragment>
    );
  }
}

export default Projects;
